import React from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import { useAuth } from '../auth/auth-context';

export default function Navigation() {
  const { token, logout } = useAuth();
  const location = useLocation();
  const hideAuthButtons = location.pathname === '/login' || location.pathname === '/register';

  return (
    <AppBar position="static" sx={{ bgcolor: '#E4E7EC', color: '#111' }}>
      <Toolbar>
        <Box
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 1,
            color: '#111',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
          }}
        >
          <Box
            component="img"
            src="/vanerix-icon-180.png"
            alt="Vanerix tiger"
            sx={{ width: 42, height: 42, objectFit: 'cover', borderRadius: '8px' }}
          />
          <Typography variant="h6" sx={{ fontSize: 20, fontWeight: 600 }}>
            Vanerix Metrics
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1 }}>
          {token ? (
            <Button
              onClick={logout}
              variant="contained"
              size="medium"
              sx={{
                bgcolor: 'grey.300',
                color: 'grey.900',
                borderRadius: '50px',
                textTransform: 'none',
                fontSize: 13,
                fontWeight: 600,
                px: 3,
                py: 1,
                boxShadow: 1,
                '&:hover': {
                  bgcolor: 'grey.400',
                  boxShadow: 3,
                },
              }}
            >
              Log Out
            </Button>
          ) : hideAuthButtons ? null : (
            <>
              <Button
                component={RouterLink}
                to="/login"
                variant="outlined"
                size="medium"
                sx={{
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                  px: 3,
                }}
              >
                Log In
              </Button>
              <Button
                component={RouterLink}
                to="/register"
                variant="contained"
                size="medium"
                sx={{
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                  px: 3,
                }}
              >
                Register
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
